import React from 'react'
import useMediaQuery from '@mui/material/useMediaQuery'
import { useTheme } from '@mui/material/styles'
const Menu = () => {
    const theme = useTheme()
    const isMobileScreen = useMediaQuery(theme.breakpoints.down('sm'))
    return (
        <div className='text-center '>
            <img src={require('../../Assets/weeklymenu.jpg')} alt='menu' className={isMobileScreen ? 'mt-2' : 'mt-5'} width={isMobileScreen ? '100%' : '50%'} height={'50%'} />
        </div>
    )
}

export default Menu